export default {"src":"/_next/static/media/logo-white.758e400a.svg","height":90,"width":436};